var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-3 pa-md-6 pa-lg-12 text-h5"},[_c('div',{staticClass:"container"},[_c('RessourceInfoBulle',{staticClass:"text-h5",attrs:{"code":"CF-DIV-1"}}),_c('RessourceInfoBulle',{staticClass:"text-h5",attrs:{"code":"CF-DIV-2"}}),_c('RessourceInfoBulle',{staticClass:"text-h5",attrs:{"code":"CF-DIV-3"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }